import Event from "./Event.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";

//const G = window.glob;

const EventMail = class extends Event {
	constructor(props) {
		super(props);
		this.state.msg = this.props.options.game.mail[this.props.event.data.ref];
	}
	isInjection() {
		return (!! this.state.msg?.injection );
	}
	additionalClassName() { return "comm mail"; }
	description() {
		const e = this.props.event;
		const from = appLib.nameByRole( e.data.from, e.data.player);
		const to = (e.data?.to ?? []).map(r => appLib.nameByRole(r)).join(', ');
		return(
			<>
				<b key={"Subject"} title={e.data.subject}>{ e.data.subject }</b>
				<span className={"Desc"} title={from}>
					<TextLabel key={"From"} value={"From"} />: { from }
				</span>
				<span className={"Desc"} title={to}>
					<TextLabel key={"To"} value={"To"} />: { to }
				</span>
				{  this.state.msg.attachments && (
					<span className={"Desc"}>
						<TextLabel value={"attach"} lang={"icon"} />
						{ this.state.msg.attachments.length > 1 && ` x ${this.state.msg.attachments.length}` }
					</span>
				)}
			</>
		);
	}
	details() {
		const m = this.state.msg;
		if ( typeof m?.body === 'undefined' ) return '';
		//console.log(m);
		return(<>
			<div key={"from"}>
				<TextLabel value={"From"}/>: «{ appLib.nameByRole( m.from ) }»
			</div>
			{ m.to && (
				<div key={"to"}>
					<TextLabel value={"To"}/>: «{ m.to.map( appLib.nameByRole ).join('», «') }»
				</div>
			) }
			<h4 key={"Subject"}>
				{ m.subject }
			</h4>
			<div key={"Body"}>
				{ m.attachments && (
					<div className={"attachments"}>
						{ m.attachments.map( appLib.attachLink ) }
					</div>
				)}
				{
					(m.html || m.body.includes('<p>')) ?
						<div className={"Html"} dangerouslySetInnerHTML={{__html: m.body }} />
						:
						<div className={"Text"}>{ m.body }</div>
				}
			</div>
		</>);
	}
}

export default EventMail;